// extracted by mini-css-extract-plugin
export default {"container":"ayubQy","inputs":"krj8Uy","descriptionPadding":"dVCSVA"};